export default __webpack_public_path__ + "static/media/nova-mensagem-grupo.6f040245.mp3";